import * as React from 'react';
import FullPageLoader from '../../components/common/full-page-loader/fullPageLoader';

type TSpinnerProps = {
	show: boolean;
}

const SpinnerComponent: React.FC<TSpinnerProps> = ({ show }) => {
    if(show) {
        return <FullPageLoader />;
    } else {
	    return <div></div>;
    }
};

export default SpinnerComponent;